module.exports = __webpack_public_path__ + "img/HC1014-167.54c0f02f.jpg";